import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { PASTE_COMMAND, COMMAND_PRIORITY_LOW } from 'lexical';

/**
 * Intercepts pasted image data and hands the File to the existing image-staging
 * flow (ChatPanel.stageImage). Non-image pastes return false so Lexical handles
 * text normally. Mirrors the old textarea's handlePaste behaviour.
 */
export default function ImagePastePlugin({ onImage }) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      PASTE_COMMAND,
      (event) => {
        const items = event.clipboardData && event.clipboardData.items;
        if (!items) return false;
        for (const item of items) {
          if (item.type && item.type.startsWith('image/')) {
            event.preventDefault();
            const file = item.getAsFile();
            if (file && onImage) onImage(file);
            return true;
          }
        }
        return false;
      },
      COMMAND_PRIORITY_LOW
    );
  }, [editor, onImage]);

  return null;
}
